"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimeOnPageTracker = /** @class */ (function () {
    function TimeOnPageTracker(logger) {
        this.logger = logger;
        this.timeOnPage = 0; // The total time on page
        this.timeOnPageSessionStart = Date.now(); // The current time on page session start time
        this.eventSent = 0; // The number of time on page events sent
        this.eventTimeout = null;
        this.visibilitychangeHandler = this.visibilitychangeCallback.bind(this);
        this.beforeunloadHandler = this.sendEvent.bind(this);
    }
    TimeOnPageTracker.prototype.start = function () {
        document.addEventListener('visibilitychange', this.visibilitychangeHandler);
        window.addEventListener('beforeunload', this.beforeunloadHandler);
        this.eventTimeout = this.setupTimeOnPageTimeout();
    };
    TimeOnPageTracker.prototype.stop = function () {
        document.removeEventListener('visibilitychange', this.visibilitychangeHandler);
        window.removeEventListener('beforeunload', this.beforeunloadHandler);
        this.clearTimeOnPageTimeout();
    };
    TimeOnPageTracker.prototype.restart = function () {
        this.stop();
        this.timeOnPage = 0;
        this.timeOnPageSessionStart = Date.now();
        this.eventSent = 0;
        this.start();
    };
    TimeOnPageTracker.prototype.sendEvent = function () {
        var currentTime = Date.now();
        this.timeOnPage += (currentTime - this.timeOnPageSessionStart) / 1000;
        this.timeOnPageSessionStart = currentTime;
        this.logger.log('time_on_page', { timeOnPage: this.timeOnPage });
    };
    TimeOnPageTracker.prototype.visibilitychangeCallback = function () {
        // document.visibilityState returns the current visibility state of the document.
        // It returns these states as “hidden“, “visible”, and “prerender”.
        // - hidden means the current tab is not in focus, either switched to another tab, minimized, or closed
        // - visible means the current tab is in focus
        // - prerender means the page has been loaded but the user has not viewed the page
        if (document.visibilityState === 'visible') {
            // If the document is change to visible, reset the session start time and continue the timeout
            this.timeOnPageSessionStart = Date.now();
            if (!this.eventTimeout) {
                this.eventTimeout = this.setupTimeOnPageTimeout();
            }
        }
        else {
            // If the document is not visible, it means the user is swtiching to another tab or closing the tab
            // Calculate the time on page and log it, also remove the timeout
            this.sendEvent();
            this.clearTimeOnPageTimeout();
        }
    };
    TimeOnPageTracker.prototype.clearTimeOnPageTimeout = function () {
        if (this.eventTimeout) {
            clearTimeout(this.eventTimeout);
            this.eventTimeout = null;
        }
    };
    // Setup the timeout for sending the time on page event exponentially
    // The events will be sent at 5, 20, 45, 90, ... seconds
    TimeOnPageTracker.prototype.setupTimeOnPageTimeout = function () {
        var _this = this;
        return setTimeout(function () {
            _this.sendEvent();
            _this.eventSent++;
            _this.eventTimeout = _this.setupTimeOnPageTimeout();
        }, 5000 * Math.pow(this.eventSent + 1, 2));
    };
    return TimeOnPageTracker;
}());
exports.default = TimeOnPageTracker;
//# sourceMappingURL=time-on-page-tracker.js.map